import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
import { ThemeContext } from "../layouts";
import Blog from "../components/Blog";
import Hero from "../components/Hero";
import Seo from "../components/Seo";
import Footer from "../components/Footer/";
import whiteLogo from "../images/logo/white.svg";
const config = require("../../content/meta/config");

class IndexPage extends React.Component {
  separator = React.createRef();

  scrollToContent = e => {
    this.separator.current.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  render() {
    const {
      data: {
        posts: { edges: posts = [] },
        bgDesktop: {
          fluid: { src: desktop, srcWebp: desktopWebP }
        },
        bgTablet: {
          fluid: { src: tablet, srcWebp: tabletWebP }
        },
        bgMobile: {
          fluid: { src: mobile, srcWebp: mobileWebP }
        },
        site: {
          siteMetadata: { facebook }
        }
      }
    } = this.props;

    const backgrounds = {
      desktop,
      tablet,
      mobile,
      desktopWebP,
      mobileWebP,
      tabletWebP
    };

    return (
      <React.Fragment>
        <ThemeContext.Consumer>
          {theme => (
            <Hero
              scrollToContent={this.scrollToContent}
              backgrounds={backgrounds}
              theme={theme}
              title={config.homePageTitle}
              subtitle={config.siteDescription}
              logo={whiteLogo}
              titleLink="/"
              displaySocial={true}
            />
          )}
        </ThemeContext.Consumer>

        <hr ref={this.separator} />

        <ThemeContext.Consumer>
          {theme => <Blog posts={posts} theme={theme} />}
        </ThemeContext.Consumer>

        <ThemeContext.Consumer>
          {theme => <Footer config={config} theme={theme} />}
        </ThemeContext.Consumer>

        <Seo facebook={facebook} />

        <style jsx>{`
          hr {
            margin: 0;
            border: 0;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default IndexPage;

//eslint-disable-next-line no-undef
export const query = graphql`
  query IndexQuery {
    posts: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" } }
      sort: { fields: [fields___prefix], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            subtitle
            date
            icon {
              childImageSharp {
                bgDesktop: resize(width: 400, height: 400, quality: 90, cropFocus: CENTER) {
                  src
                }
                bgTablet: resize(width: 250, height: 250, quality: 90, cropFocus: CENTER) {
                  src
                }
                bgMobile: resize(width: 100, height: 100, quality: 90, cropFocus: CENTER) {
                  src
                }
              }
            }
            tags
            author
            cover {
              children {
                ... on ImageSharp {
                  fluid(maxWidth: 800, maxHeight: 360) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
    bgDesktop: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      fluid(maxWidth: 1200, quality: 90, cropFocus: CENTER) {
        src
        srcWebp
      }
    }
    bgTablet: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      fluid(maxWidth: 800, maxHeight: 1100, quality: 90, cropFocus: CENTER) {
        src
        srcWebp
      }
    }
    bgMobile: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      fluid(maxWidth: 450, maxHeight: 850, quality: 90, cropFocus: CENTER) {
        src
        srcWebp
      }
    }
  }
`;

//hero-background
